<template>
  <div>
    <applicationForm :applicationEditId="applicationId" :applicationDetail="applicationDetail" :formType="formType" :isEdit="true"></applicationForm>
  </div>
</template>

<script>
import {
  getApplicationDetail,
} from "@/api/parent/application";
import applicationForm from "./components/applicationForm.vue";
export default {
  components: {
    applicationForm,
  },
  props: {
    applicationId: {
      type: Number,
      default: 0,
    },
    formType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
        applicationDetail: {}
    }
  },
  created() {
    this.getApplicationDetail();
  },
  methods: {
    getApplicationDetail() {
      getApplicationDetail(this.applicationId).then((res) => {
          this.applicationDetail = res.data;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
</style>